import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { NavLink, useLocation } from 'react-router-dom';

import { authService } from '@S';
import { useGlobalStore } from '@stores/globalStore';

import packageJson from '/package.json';
import { set } from 'lodash';

const Navbar = () => {
  const location = useLocation();
  const [activePath, setActivePath] = useState('');

  const navigationData = useGlobalStore((state) => state.navigationData);

  const env = process.env.ENVIRONMENT;

  useEffect(() => {
    setActivePath(location.pathname);
  }, [location]);

  return (
    <div className="nav-wrapper expanded">
      <span className="app-version">v{packageJson.version}</span>
      <nav>
        <ul>
          {navigationData.map((link, index) => {
            if (link.enabled === false) return null;
            if (
              !link.roles.some(
                (item) => item.role_type === authService.currentUserRoleCode,
              )
            ) {
              return null;
            }
            if (!link.environment.some((item) => item.name === env)) {
              return null;
            }
            return (
              <li key={index}>
                <NavLink
                  className={
                    activePath.split('/')[2]?.includes(link.path.split('/')[2])
                      ? 'active'
                      : ''
                  }
                  activeClassName="active"
                  to={`${link.title.toLowerCase() === 'dsr' ? link.path + '/' + dayjs().format('YYYY-MM-DD') : link.path}`}
                >
                  <span className={link.icon} />
                  <span>{link.title}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>

      <div className="wave-container">
        <div className="navbar-logo" />
        <div className="wave-wrapper">
          <div className="wave" />
          <div className="wave" />
        </div>
      </div>
    </div>
  );
};

export default Navbar;

export { Navbar };
